<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

</script>

<div id = 's8-layout-full'>
    <slot></slot>
</div>

<style lang='postcss'>

    div#s8-layout-full {
        @apply absolute top-0 left-0 right-0 bottom-0;
    }

</style>